export const createNavigationCta = (navigationService: any) => {
	return (environmentPath: string) => {
		const target = navigationService.navigateTo(environmentPath, {});

		if (target) {
			target.push();
		}
	};
};
